import React, { useState } from 'react';
import _ from 'lodash';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { matchSorter } from 'match-sorter';
import { XIcon } from '@heroicons/react/outline';
import { keywordAtom, menuAtom, itemAtom } from '../../../atoms/Atoms';
import './Popup.css'; // Import your styles

function Popup({ onClose, photo, details, price, cta, search }) {
  const [keyword, setKeyword] = useRecoilState(keywordAtom);
  const setItem = useSetRecoilState(itemAtom);
  const menu = useRecoilValue(menuAtom);

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="flex flex-col">
          <button type="button" className="close-button ml-auto" onClick={onClose}>
            <XIcon className="w-4 h-4 text-gray-700" />
          </button>
          {photo !== null ?
            <div className="image-container">
              <img src={photo} alt="Product" className="popup-image" />
            </div>
          : null}
          <p className="text-center">{details}</p>
          <p className="popup-price text-center"><span style={{ color: 'red' }}>{price}</span></p>
          {cta && (
            <button
              type="button"
              className="add-to-cart-button mx-auto mt-4"
              onClick={() => {
                onClose();
                if (search !== null) {
                  // setKeyword(search);
                  const tempItems = _.map(menu?.sections, (category) =>
                    _.map(
                      matchSorter(category.items, search, {
                        keys: ['name'],
                      }),
                      (i) => i
                    )
                  );
                  if (tempItems.length > 0) {
                    if (tempItems[0].length > 0) {
                      setItem(tempItems[0][0]);
                    }
                  }
                }
              }}
            >
              {cta}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Popup;
